module.exports = __webpack_public_path__ + "static/img/wlhxt53.2a610fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wlhxt53.jpg
// module id = qf7K
// module chunks = 73